import { Component, ElementRef, OnInit, ViewChild, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ConstructAPI } from 'src/app/API/constructAPI';
import { RestApiService } from 'src/app/API/restapi';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { Company } from 'src/model/company.model';
import { Contact } from 'src/model/contact.model';
import { Customer } from 'src/model/customer.model';
import { CompanyService } from 'src/services/company.service';
import { CustomerService } from 'src/services/customer.service';

@Component({
    selector: 'app-guarantor-form',
    templateUrl: './guarantor-form.component.html',
    styleUrls: ['./guarantor-form.component.scss'],
    standalone: false
})
export class GuarantorFormComponent implements OnInit {
  private activatedRoute = inject(ActivatedRoute);
  private restapi = inject(RestApiService);
  private constructApi = inject(ConstructAPI);
  protected sharedService = inject(SharedService);
  private customerService = inject(CustomerService);
  private companyService = inject(CompanyService);


  selectedCompany: Company;
  selectedCustomer: Customer;
  selectedCustomerID: number;
  selectedCompanyID: number;
  selectedContactID: number;
  contact: Contact;

  date: Date;
  amount: number;
  formJDate: Date;

  epfSettlementAge: number;

  @ViewChild('htmlData') htmlData: ElementRef;

  routeSubscription: any;

  constructor() {
    this.routeSubscription = this.activatedRoute.paramMap.subscribe(async params => {
      this.selectedCustomerID = + params.get('customerId');
      this.selectedCompanyID = + params.get('companyId');
      this.selectedContactID = + params.get('contactId');

      this.getCompanyInfo();
      this.getContactInfo();

      this.selectedCustomer = await this.customerService.getCustomerDetails(this.selectedCustomerID),
      this.epfSettlementAge = this.sharedService.defineEPFTier(new Date(this.selectedCustomer.DOB));
    })
  }

  ngOnInit(): void {
  }

  getContactInfo() {
    const xhttp = this.restapi.getRequest(this.constructApi.getContactDetails(this.selectedContactID))
    xhttp.onreadystatechange = () => {
      if (xhttp.readyState == 4 && xhttp.status == 200) {
        const json = JSON.parse((xhttp.responseText));
        this.contact = new Contact(json.id, json.name, json.icNumber, json.number, undefined, undefined, undefined, undefined);
      }
    }
  }

  async getCompanyInfo() {
    this.selectedCompany = await this.companyService.getCompanyDetails(this.selectedCompanyID);
  }
}
